module.exports = __webpack_public_path__ + "2cdc7935f7572be826da7e42b11b8c95.svg";